import React from 'react';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";

import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";
import size from "lodash/size";

import {getPriceWithCurrency, getQuotePriceWithTaxes, getTotalPrice} from "../../misc/helpers";
import {toggleInstOpened, toggleUserPopup, changeMessageBoxState, clearCart} from "../../actions/actionFunctions";

// import UserLoginButton from "../ui/userLoginButton";
import InstallButton from "../ui/installButton";
import Analytics from './../../analytics';
//import store from '../../store';
import ShoppingCart from "./shoppingCart";
import ShareButton from "../common/shareButton";
import {toggleShowMobileQuotes} from "../../actions/shoppingCartFunctions";
import ShoppingCartListSwitcher from "./shoppingCartListSwitcher";
import LanguageSwitcher from "../common/languageSwitcher";
import AdvancedQuotingSwitcher from "./advancedQuoting/advancedQuotingSwitcher";
import CloneQuoteButton from "../popups/orderCompletePopup/cloneQuoteButton";

class ShoppingCartMobileHeader extends ShoppingCart {

  static propTypes = {
    questionShown: PropTypes.bool,
    isPhoneNumberValidated: PropTypes.bool.isRequired
  };

  handleSaveClick = () => {
    Analytics.sendClickEvent("mobile-header-save");
    this.handleCheckOut();
  };

  toggleUserPopup = () => {
    Analytics.sendClickEvent("mobile-header-user-popup");
    this.props.toggleUserPopup({userPopupOpened: true});
  };

  toggleShowMobileQuotes = () => {
    Analytics.sendClickEvent("mobile-toggle-rooms");
    this.props.toggleShowMobileQuotes(!this.props.showMobileQuotes);
  };

  render() {
    const {fabricatorData} = this.props;
    const fabricatorSettings = fabricatorData.settings;
    const {isPhoneNumberValidated, instList, discountSections} = this.props;
    const {isBackend, jobId, canSaveQuote} = document.kvConfig;
    const totalPrice = getTotalPrice();
    let grandTotal = getQuotePriceWithTaxes(totalPrice, discountSections);
    const pricingIsLocked = (fabricatorSettings.leadCaptureOnQuote || fabricatorSettings.leadCaptureShoppingCart)
      && !(isBackend && jobId && canSaveQuote) && !isPhoneNumberValidated;
    grandTotal = grandTotal.toFixed(2); // always round to 23.65, even if it is 23.00

    return (
      <div className="scart-header">
        <div
          className={"scart-header__left" + (!(fabricatorSettings.showPricing) ? " scart-header__left--no-price" : "")}>
          {fabricatorSettings.showPricing && !fabricatorData.hidePricesFromUser ? (
            <div className="scart-header__left-total total">
              <span className="total-title"><FormattedMessage id="shoppingCart.mobile.header.total"/></span>
              {pricingIsLocked
                ? <span className="total-price--locked" onClick={this.toggleUserPopup}>
                    <FormattedMessage id="shoppingCart.mobile.header.pricingLocked"/>
                  </span>
                : <span className="total-price">{getPriceWithCurrency(fabricatorSettings, grandTotal)}</span>}
            </div>
          ) : null}
          {/*<button className="scart-header__left-cart materials-button materials-button--cart">*/}
          {/*  {cartItems.length*/}
          {/*    ? <span className="materials-button--cart-length bold">{cartItems.length}</span>*/}
          {/*    : null}*/}
          {/*</button>*/}
        </div>
        <div className="scart-header__buttons">
          <div className="scart-header__buttons-inner">
            <div className="scart-header__buttons-inner__left">
              <AdvancedQuotingSwitcher/>
              <ShoppingCartListSwitcher/>
              <CloneQuoteButton/>
              <LanguageSwitcher/>
              <button className={"materials-button materials-button--room"
              + (this.props.showMobileQuotes ? " materials-button--active" : "")}
                      onClick={this.toggleShowMobileQuotes}>
                <span className="materials-button__text">
                  <FormattedMessage id="shoppingCart.mobile.header.roomsButton"/>
                </span>
              </button>
              {fabricatorSettings.enableSharing ? <ShareButton renderList={true}/> : null}
              {/*{(fabricatorSettings.leadCaptureOnQuote && !(document.kvConfig.isBackend && document.kvConfig.jobId && document.kvConfig.canSaveQuote)) ? <UserLoginButton/> : null}*/}
              {fabricatorSettings.separateLaborInCart && this.props.location.pathname === '/shoppingcart' && size(instList)
                ? <InstallButton questionShown={this.props.questionShown}/> : null}
            </div>
            {/*<div className="scart-header__buttons-inner__right">*/}
            {/*  {this.getFinalButton()} // carefully, it is returning object now*/}
            {/*</div>*/}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  const {cartItems, showMobileQuotes} = store.cartState;
  return {
    userIsLoggedIn: store.userState.userIsLoggedIn,
    isPhoneNumberValidated: store.userState.isPhoneNumberValidated,
    cartItems,
    instList: store.instState.instList,
    fabricatorData: store.fabricatorState,
    fabricatorTaxes: store.fabricatorState.fabricatorTaxes,
    discountSections: store.priceWorksheetState.discountSections,
    showMobileQuotes,
  };
};

const ShoppingCartMobileHeaderWithRouter = withRouter(props => <ShoppingCartMobileHeader {...props}/>);

const mapDispatchToProps = {
  toggleInstOpened,
  toggleUserPopup,
  changeMessageBoxState,
  clearCart,
  toggleShowMobileQuotes,
};

export default connect(mapStateToProps, mapDispatchToProps)(ShoppingCartMobileHeaderWithRouter);
